module.exports = __webpack_public_path__ + "img/open-2.2f41117f.png";